import React from 'react'
import { styled } from 'styled-components'
import FlipMove from 'react-flip-move'
import BasicNotification from './BasicNotification'
import { type Notification } from './constants'
import usePlayerNotifications from './hook'
import {
	isClassQuestionScreen,
	useMissionStateSelector,
	useIsShowingASLVideo,
} from '../../../context'

function generateAnimation(isLeaving: boolean): {
	from: { transform: string },
	to: { transform: string },
} {
	const fromValue = isLeaving ? 0 : -100
	const toValue = isLeaving ? -100 : 0
	return {
		from: { transform: 'translateX(' + fromValue + '%)' },
		to: { transform: 'translateX(' + toValue + '%)' },
		reset: false,
	}
}
const ENTER_ANIMATION = generateAnimation(false)
const LEAVE_ANIMATION = generateAnimation(true)

export default function Notifications(): React$Node {
	const notifications: Array<Notification> = usePlayerNotifications()
	const isPlayingAccessibilityVideo = useIsShowingASLVideo()
	const isClassQuestion = useMissionStateSelector(isClassQuestionScreen)

	return (
		notifications.length && (
			<NotificationsWrapper
				$lower={isPlayingAccessibilityVideo}
				$culminating={isClassQuestion}>
				<FlipMove
					enterAnimation={ENTER_ANIMATION}
					leaveAnimation={LEAVE_ANIMATION}>
					{notifications.map((notification: Notification, index: number) => {
						if (index > 2) {
							return null
						}
						return (
							<BasicNotification
								key={notification.id}
								notificationObject={notification}
							/>
						)
					})}
				</FlipMove>
			</NotificationsWrapper>
		)
	)
}

const NotificationsWrapper = styled.div`
	overflow: hidden;
	position: absolute;
	// height is needed to get the FlipMove to work.
	height: 50%;
	width: 30%;
	top: 0;
	left: 0;
	display: flex;
	flex-direction: column;
	margin-top: ${({ $lower, $culminating }) =>
		$lower ? `20%` : $culminating ? '10%' : '0'};
	z-index: ${({ theme }) => theme.zOverlay};
`
